module.exports = __webpack_public_path__ + "img/baden_express_logo.786dac0f.png";